module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread7.97fa43ed.jpg";